import { ReactElement } from 'react';
import { LambdaGetFunctionScalingConfigResponse } from '@localstack/types';
import { getSchema } from '@localstack/services';

import { MagicDetails } from '../../magic/MagicDetails';

export interface LambdaFunctionScalingConfigDetailsProps {
  data?: Optional<Partial<LambdaGetFunctionScalingConfigResponse>>;
}

export const LambdaFunctionScalingConfigDetails = ({ data }: LambdaFunctionScalingConfigDetailsProps): ReactElement => (
  <MagicDetails
    data={data}
    schema={getSchema('Lambda')}
    entry="GetFunctionScalingConfigResponse"
    title="Function Scaling Config Details"
  />
);
